import axios from 'axios';

export async function sendApiRequest(api_name, params = {}, method = "GET") {
    // Check if API base URL is set
    if (!process.env.REACT_APP_API_BASE_URL) {
        console.error('API Base URL is not set in environment variables');
        return {
            status: false,
            message: 'API configuration error. Please contact support.'
        };
    }

    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const url = `${baseUrl}/${api_name}`;


    try {
        const options = {
            url: url,
            method: method.toUpperCase(),
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        };

        // Only add Authorization header if token exists
        const token = localStorage.getItem("auth_token");
        if (token) {
            options.headers.Authorization = `Bearer ${token}`;
        }

        // Add data or params based on method
        if (method.toUpperCase() === 'GET' || method.toUpperCase() === 'DELETE') {
            options.params = params;
        } else {
            options.data = params;
        }


        const response = await axios(options);
        return response.data;
    } catch (error) {
        console.error('API Error Details:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
            config: error.config
        });

        // Network error
        if (!error.response) {
            console.error('Network Error - No response received');
            return {
                status: false,
                message: 'Network error. Please check your internet connection.'
            };
        }

        // Server error
        if (error.response?.data) {
            return {
                status: false,
                message: error.response.data.message || error.response.data.error || 'Server error occurred',
                data: error.response.data
            };
        }

        // Unknown error
        return {
            status: false,
            message: 'An unexpected error occurred. Please try again.'
        };
    }
} 